var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M673.73 333.61H493a5.87 5.87 0 0 1-5.86-5.86V64.47a5.87 5.87 0 0 1 5.86-5.86h180.73a5.87 5.87 0 0 1 5.87 5.86v263.28a5.87 5.87 0 0 1-5.87 5.86ZM493 58.86a5.61 5.61 0 0 0-5.61 5.61v263.28a5.61 5.61 0 0 0 5.61 5.61h180.73a5.62 5.62 0 0 0 5.62-5.61V64.47a5.62 5.62 0 0 0-5.62-5.61ZM465.31 333.61H284.56a5.87 5.87 0 0 1-5.86-5.86V64.47a5.87 5.87 0 0 1 5.86-5.86h180.75a5.87 5.87 0 0 1 5.86 5.86v263.28a5.87 5.87 0 0 1-5.86 5.86ZM284.56 58.86a5.62 5.62 0 0 0-5.56 5.61v263.28a5.62 5.62 0 0 0 5.61 5.61h180.7a5.62 5.62 0 0 0 5.61-5.61V64.47a5.62 5.62 0 0 0-5.61-5.61ZM257 333.61H76.27a5.87 5.87 0 0 1-5.87-5.86V64.47a5.87 5.87 0 0 1 5.87-5.86H257a5.87 5.87 0 0 1 5.86 5.86v263.28a5.87 5.87 0 0 1-5.86 5.86ZM76.27 58.86a5.62 5.62 0 0 0-5.62 5.61v263.28a5.62 5.62 0 0 0 5.62 5.61H257a5.61 5.61 0 0 0 5.61-5.61V64.47a5.61 5.61 0 0 0-5.61-5.61ZM0 394.68h750v.12H0z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ebebeb"
    },
    d: "M653.63 424.06h55.73v.42h-55.73zM495.04 428.62h14.63v.42h-14.63zM40.64 411.26h72.67v.42H40.64zM128.3 411.26h10.66v.42H128.3zM173.59 418.36H331.2v.42H173.59z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.31 173.76a9.6 9.6 0 0 0-5.46-1.37c-1.17-1.43-.22-3.57.91-5s2.53-3.1 2.1-4.9c-.67-2.7-4.46-2.81-7.19-2.28-1-1.63-1-3.65-1.48-5.54s-2.09-3.86-3.88-3.59-2.89 2.24-4.65 2.66c-2.05.48-3.83-1.33-5.43-2.69a7.36 7.36 0 0 0-.63-.47c.34-5.62 5.69-4.72 10.24-5.49 3.56-.59-5.87-9.59 1.32-12.49a6.38 6.38 0 0 0 3.47-2.4 4.09 4.09 0 0 0-1.58-5 9.6 9.6 0 0 0-5.44-1.36c-1.17-1.43-.23-3.58.91-5s2.52-3.1 2.1-4.9c-.68-2.7-4.46-2.81-7.19-2.28-1-1.63-1-3.66-1.48-5.54s-2.08-3.86-3.88-3.6-2.89 2.25-4.66 2.67c-2.05.48-3.82-1.34-5.43-2.69s-4.41-2.21-5.51-.42c-.66 1.06-.27 2.54-1 3.6-1.19 1.8-4 .69-5.78-.6s-4.58-2.47-5.78-.67a7.35 7.35 0 0 0-.68 1.87 5.23 5.23 0 0 1-.71 1.29c-.35-1.25-.46-2.6-.78-3.86-.49-1.87-2.09-3.86-3.89-3.6s-2.89 2.26-4.65 2.67c-2.05.49-3.82-1.34-5.43-2.69s-4.41-2.21-5.52-.41c-.66 1.06-.26 2.54-1 3.6a1.79 1.79 0 0 1-.57.59 9.23 9.23 0 0 0-1.81-.12c-1.18-1.42-.23-3.55.91-5s2.53-3.11 2.1-4.9c-.67-2.71-4.46-2.81-7.2-2.28-1-1.64-1-3.67-1.47-5.54s-2.09-3.87-3.89-3.59-2.89 2.25-4.65 2.67c-2.05.48-3.82-1.32-5.43-2.69s-4.41-2.2-5.52-.42c-.65 1-.26 2.55-1 3.6-1.19 1.79-4 .68-5.77-.61s-4.59-2.47-5.79-.67a7 7 0 0 0-.69 1.88c-.82 2.4-3.43 3.6-5.44 5.13s-3.61 4.6-1.91 6.47c.84.93 2.33 1.28 2.75 2.48.51 1.41-1 2.79-2.18 3.81a6.26 6.26 0 0 0-1.2 6.42 5.62 5.62 0 0 1-2.08 1.19c-2 .48-3.82-1.33-5.43-2.68s-4.41-2.21-5.51-.42c-.66 1-.27 2.54-1 3.6-1.19 1.79-4 .69-5.77-.6s-4.59-2.47-5.79-.67a7.48 7.48 0 0 0-.69 1.87c-.82 2.39-3.43 3.59-5.44 5.13s-3.61 4.59-1.91 6.47c.81.94 2.2 1.32 2.68 2.4-1.42-.56-3.05-.42-3.71.64s-.26 2.54-1 3.59c-1.18 1.8-4 .7-5.76-.6s-4.6-2.47-5.8-.67a7.57 7.57 0 0 0-.68 1.88c-.83 2.4-3.43 3.58-5.44 5.12s-3.61 4.61-1.91 6.48c.84.92 2.33 1.28 2.75 2.48.52 1.42-1 2.8-2.17 3.81-2 1.68-2.35 6.73.27 8.12 1.11.58 2.75.88 3 2s-.87 1.93-1.6 2.77a5.1 5.1 0 0 0-.45.69 5.2 5.2 0 0 0 2.05 7.07c.63.28 1.4.54 1.64 1.2a2.52 2.52 0 0 1-.16 1.46 8.12 8.12 0 0 0-.25 2.82 1 1 0 0 0 1.18 1.11c3.79.17 5.61-1.17 7.92 2.12a2.79 2.79 0 0 0 .8.84 2.34 2.34 0 0 0 1 .25c2.6.22 4.28-1.4 6.68-1.71 3.32-.42 4 1.28 6.92 2.65 4.56 2.16 6.78.83 7.65-2.29a13.65 13.65 0 0 0 .4-2.7 4.73 4.73 0 0 1 1.6-3.6h.07c2.43.21 4.08-1.18 6.21-1.61l1.36-.15c2.53 0 3.37 1.5 6 2.7a9.08 9.08 0 0 0 3.91 1c.38 1.42-1 2.69-2.21 3.67-2 1.69-2.33 6.74.29 8.12 1.09.58 2.75.9 3 2s-.87 1.93-1.6 2.76a4.45 4.45 0 0 0-.45.68 5.23 5.23 0 0 0 2.05 7.09c.62.3 1.4.54 1.63 1.19a2.5 2.5 0 0 1-.15 1.48 7.6 7.6 0 0 0-.25 2.81 1 1 0 0 0 1.18 1.11c3.79.17 5.61-1.17 7.92 2.12a2.54 2.54 0 0 0 .79.84 2.77 2.77 0 0 0 1.05.27c2.6.21 4.28-1.42 6.68-1.72 3.31-.42 4 1.28 6.9 2.65 4.58 2.15 6.8.83 7.66-2.29a13.05 13.05 0 0 0 .41-2.71c.34-5.61 5.69-4.72 10.25-5.48a.89.89 0 0 0 .75-.51h.29c2.6.21 4.28-1.41 6.67-1.72 3.33-.42 4 1.28 6.92 2.65 4.57 2.16 6.79.83 7.65-2.29a13.05 13.05 0 0 0 .41-2.71c.3-4.36 3.6-4.79 7.19-5.13a5 5 0 0 0 2.64 4.09c.64.29 1.41.54 1.65 1.2a2.61 2.61 0 0 1-.16 1.46 7.82 7.82 0 0 0-.25 2.81 1.26 1.26 0 0 0 .33.88 1.4 1.4 0 0 0 .84.24c3.79.17 5.61-1.17 7.93 2.13a2.72 2.72 0 0 0 .79.83 2.35 2.35 0 0 0 1 .26c2.6.21 4.28-1.41 6.68-1.72 3.32-.42 4 1.28 6.92 2.65 4.57 2.16 6.79.83 7.65-2.29a13.66 13.66 0 0 0 .41-2.7c.33-5.62 5.69-4.72 10.25-5.49 3.56-.59-5.89-9.59 1.31-12.49a6.36 6.36 0 0 0 3.46-2.4 4.07 4.07 0 0 0-1.2-4.85Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.87 207.27a7.88 7.88 0 0 0-4.54-1.14c-1-1.2-.18-3 .76-4.19s2.11-2.54 1.74-4.09c-.54-2.26-3.69-2.33-6-1.89-.85-1.37-.82-3.07-1.26-4.62s-1.65-3.17-3.24-3-2.41 1.88-3.88 2.22c-1.7.41-3.19-1.1-4.52-2.23s-3.68-1.84-4.61-.36c-.54.89-.21 2.15-.78 3-1 1.53-3.35.58-4.82-.5s-3.81-2.06-4.83-.56a7.1 7.1 0 0 0-.57 1.56c-.68 2-2.84 3-4.53 4.27s-3 3.81-1.58 5.4c.7.77 1.93 1.09 2.28 2.07.43 1.26-.82 2.33-1.81 3.17-1.65 1.41-2 5.62.23 6.76.92.48 2.27.64 2.53 1.65s-.71 1.61-1.27 2.31a4.35 4.35 0 0 0 .77 6.09 4.28 4.28 0 0 0 .57.37c.52.25 1.16.46 1.35 1a2 2 0 0 1-.12 1.27 6.37 6.37 0 0 0-.21 2.34 1.09 1.09 0 0 0 .28.73 1.11 1.11 0 0 0 .7.21c3.15.14 4.67-1 6.6 1.76a2.32 2.32 0 0 0 .66.7 2 2 0 0 0 .87.21c2.17.18 3.58-1.16 5.57-1.42 2.75-.35 3.33 1.07 5.75 2.21 3.81 1.79 5.67.69 6.35-1.92a11.23 11.23 0 0 0 .34-2.24c.28-4.68 4.74-4 8.54-4.58 3-.5-4.89-8 1.09-10.41a5.2 5.2 0 0 0 2.89-2 3.38 3.38 0 0 0-1.3-4.15Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m231.89 181.4 4.89-15.51 9.52-12.24-1.63-1.36-9 9.79-1.59-15.51h-2.6s2.13 18.43-.94 25.17c0 0-11.16 28.4-18 34.54a6.44 6.44 0 0 0-1 1.21 70.59 70.59 0 0 0-7.89-14.8c2.69-6.86 8.44-21.95 10.4-30a159.59 159.59 0 0 0 3.44-19l-2.22-.25s-6.32 29.82-16.76 43.4a41.39 41.39 0 0 0-10.39-7c-.85-4.19-1.21-11.48 1.56-22.87l-2.2-.56a54.61 54.61 0 0 0-3.85 21.2 38.3 38.3 0 0 1-4.53-2.69C169.11 167.8 162 155 162 155l-2 2s8.59 18.85 20.55 25.15 19.72 21.64 20.34 25.66c.17 1.15 1.55 10.26-.37 26.22-12.73-5.43-38-20.38-39.63-21.76l-2.94 4 40.82 29.2c.64 38.92-2.3 79.41-2.2 88.17h23.77c-.58-12.08-5.59-57.53-3.37-105 .19-1.17.39-2.51.58-4.07 1.86-14.56 12.91-34.47 18.17-40.13a110.27 110.27 0 0 1 11.9-10.87l-1.44-3.1Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420 61.1a5.64 5.64 0 0 0-5.63-5.63 5.46 5.46 0 0 0-1.61.24 12.47 12.47 0 0 0 .12-1.73A11.92 11.92 0 0 0 401 42.06a12.3 12.3 0 0 0-2.19.2 10.42 10.42 0 0 0-19.32 5.27h-.18a9.61 9.61 0 0 0 0 19.21h35.26A5.62 5.62 0 0 0 420 61.1Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.58 117a5.22 5.22 0 0 0-5.22-5.22 4.68 4.68 0 0 0-1.49.22 12.32 12.32 0 0 0 .11-1.61 11.06 11.06 0 0 0-11.06-11 11.52 11.52 0 0 0-2 .18 9.67 9.67 0 0 0-17.92 4.87h-.16a8.91 8.91 0 0 0 0 17.82h32.71a5.21 5.21 0 0 0 5.03-5.26Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.61 43.32a3.14 3.14 0 0 0-3.14-3.14 2.73 2.73 0 0 0-.9.13 7.73 7.73 0 0 0 .06-1A6.64 6.64 0 0 0 200 32.7a6.39 6.39 0 0 0-1.23.11A5.81 5.81 0 0 0 188 35.75h-.1a5.36 5.36 0 0 0 0 10.71h19.66a3.14 3.14 0 0 0 3.05-3.14ZM667 60.85a5.47 5.47 0 0 0-5.48-5.47 5.17 5.17 0 0 0-1.56.23 11.87 11.87 0 0 0 .12-1.68 11.63 11.63 0 0 0-13.72-11.4 10.14 10.14 0 0 0-18.79 5.13h-.17a9.34 9.34 0 0 0 0 18.68h34.28a5.47 5.47 0 0 0 5.32-5.49Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.64 127.37a6.19 6.19 0 0 0-6.19-6.19 6.27 6.27 0 0 0-1.77.26 12.05 12.05 0 0 0 .13-1.9 13.12 13.12 0 0 0-15.51-12.88 11.45 11.45 0 0 0-21.23 5.79h-.2a10.57 10.57 0 0 0 0 21.12h38.76a6.18 6.18 0 0 0 6.01-6.2ZM612.92 333.28h6.45V103.06a21 21 0 0 0-21-21h-5.7v6.45h5.7a14.52 14.52 0 0 1 14.5 14.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.43 90h46.44l-1.06-7a5.41 5.41 0 0 0-4.56-4.54c-3.06-.45-7.06-1-8.94-1-5.49-.12-19 1.29-25.66 2a5.38 5.38 0 0 0-4.65 4.09Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.34 94.91H593a4.91 4.91 0 0 0 4.91-4.9h-46.48a4.9 4.9 0 0 0 4.91 4.9Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "m582.14 105.1 8.71 20.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.85 125.9a.26.26 0 0 1-.23-.16l-8.71-20.54a.25.25 0 0 1 .14-.33.23.23 0 0 1 .32.13l8.71 20.55a.25.25 0 0 1-.13.33ZM572.88 138.94a.25.25 0 0 1-.25-.25c0-5.93.19-11.46.37-16.8s.36-10.86.36-16.79a.25.25 0 0 1 .5 0c0 5.93-.19 11.46-.36 16.8s-.37 10.86-.37 16.79a.25.25 0 0 1-.25.25ZM553.64 121.15a.3.3 0 0 1-.16-.05.24.24 0 0 1 0-.35L566.15 104a.25.25 0 0 1 .35-.05.24.24 0 0 1 0 .35l-12.71 16.71a.24.24 0 0 1-.15.14Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.6 451.63c0 3.39-117.57 6.13-262.6 6.13s-262.6-2.76-262.6-6.13S230 445.5 375 445.5s262.6 2.75 262.6 6.13Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.88 73.79h98.63a13.14 13.14 0 0 1 13.14 13.14v211.26a17 17 0 0 1-17 17H65.77a17 17 0 0 1-17-17V86.93a13.14 13.14 0 0 1 13.11-13.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m137.09 79.21-2 4H86.21l-2.9-4H60.2a6.65 6.65 0 0 0-6.69 6.61v213a10.06 10.06 0 0 0 10.11 10h95.15a10.05 10.05 0 0 0 10.11-10v-213a6.65 6.65 0 0 0-6.69-6.61Z",
    style: {
      fill: "#ffb600"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.13,
    cy: 78.83,
    r: 2.01,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.11 78.83a1 1 0 1 1-1-1 1 1 0 0 1 1 1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.19 79.21h-25.1l-2 4H86.21l-2.9-4H60.2a6.65 6.65 0 0 0-6.69 6.61v54.49h115.37V85.82a6.65 6.65 0 0 0-6.69-6.61Z",
    style: {
      fill: "#ffb600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.6000000000000001
    },
    d: "M153.03 83.4h.9v2.03h-.9zM154.55 82.66h7.2v3.52h-7.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.4
    },
    d: "M53.64 131.19h115.2v170.58H53.64z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.84 157.43v-8.54l-27.1 25-28.62-9.53 17.93-33.16h-7.21l-7.64 14.1-55.45-14.12h-7.09v4.59l20.87 5.29-16.94 29.83 39.73 9.34L92.6 189l-39-9.77v6.39l35.91 9-11.58 21.46-18.36-5.16-5.93 3.74v7.41l7-4.41 14.29 4L53.64 261v13.35l13.91-25.72L86.47 254v23.47l38.53 24.3h12.6l-44.73-28.2v-17.78l76 21.53v-6.44l-22.67-6.45 6.93-36.85 15.78 4v-6.38l-42.61-10.78 18.89-35.14Zm-101.63 9.35 13.72-24.07 32.26 8.22-12.8 23.66ZM146.85 226 140 262.7 70.57 243l19.44-36 7.44 8 23.38 4.41Zm-27-13.06-19-3.61-7.62-8.15 16.93-31.32 27.84 9.29Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.84 121.66H82a4.31 4.31 0 0 1-4.31-4.29 4.31 4.31 0 0 1 4.3-4.3h66.85a4.3 4.3 0 0 1 4.28 4.32 4.3 4.3 0 0 1-4.28 4.27Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.47 114.32a3.29 3.29 0 0 0-4.66 0 3.3 3.3 0 0 0 0 4.62l2.31 2.31 2.31-2.31a3.3 3.3 0 0 0 .04-4.62Zm-1.29 3.37a1.47 1.47 0 1 1 0-2.08 1.46 1.46 0 0 1 0 2.08ZM142.37 261.43a4.19 4.19 0 1 0 4.34 4.19 4.26 4.26 0 0 0-4.34-4.19Zm0 6.91a2.73 2.73 0 1 1 2.82-2.72 2.77 2.77 0 0 1-2.82 2.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.09 265.62a1.72 1.72 0 1 1-1.72-1.66 1.7 1.7 0 0 1 1.72 1.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m127.5 145.89-9.15 17.05 23.4 6.93L154.67 157a247.84 247.84 0 0 1-27.17-11.11ZM168.84 131.18v11.64l-11.45 11.48c-7.7-2.65-15.3-5.51-22.7-8.83-1.87-.83-3.73-1.7-5.56-2.6l6.23-11.69ZM111.24 173.64l21.73 7.07-10.87 21.94-22.05-6.84 11.19-22.17zM133 211.41c.19-.59 10.68-21.54 10.68-21.54l15.54 4.67 2.74 23.69ZM147.46 185.67l16.28 4.2 1.31-17.84-14.7 7.76-2.89 5.88zM101.16 243.9c.33-.26 7.55-21.73 7.55-21.73l33.66 5.72-5.61 28.66ZM83.05 231.63l10.15 3.23-5.08 9s-10.69-2.37-10.69-3.06 5.62-9.17 5.62-9.17ZM83.61 258.81c-.25.59-6.42 43-6.42 43H53.64l.7-14.43 14.26-31.7ZM168.84 279.73v17.89l-25.75 1-22.38-16.09s3.85-10.7 5-14.1ZM122.27 267.47l-19.33-5.08-2.75 9.17 17.5 9.13s4.58-12.35 4.58-13.22ZM168.84 243.02v19.54l-17.79-3.75 3.62-18.49 14.17 2.7zM62.4 205.57l5.64-12.44 15.71 4.47-6.32 13-15.03-5.03zM76.71 162.29l7.75-13.54 21.01 5.88-7.05 14.46-21.71-6.8zM118.7 131.18c-2 3.8-4.46 8.63-4.86 8.94s-26.38-6.05-37.84-8.94ZM68.03 144.78 53.64 173.8v-32.63l14.39 3.61z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.09 260.58h-.16a.9.9 0 0 1-.74-1l6.25-34.84a447.6 447.6 0 0 0-49.51-11.56.94.94 0 0 1-.52-.27l-10.55-11a.86.86 0 0 1-.14-1L101 178.12l-38.71-8.45a.88.88 0 0 1-.69-1.06.92.92 0 0 1 .09-.23l13-22.94a1 1 0 0 1 1.26-.34.88.88 0 0 1 .35 1.22l-12.51 21.92 38.69 8.45a.89.89 0 0 1 .69 1.06.6.6 0 0 1-.08.21L90.6 201.15l9.9 10.33a447.77 447.77 0 0 1 50.22 11.8.88.88 0 0 1 .63 1L145 259.84a.91.91 0 0 1-.91.74ZM79.61 134a5 5 0 0 0-7 0 5 5 0 0 0 0 7l3.5 3.5 3.5-3.5a5 5 0 0 0 0-7Zm-2 5.08a2.23 2.23 0 1 1 0-3.15 2.23 2.23 0 0 1 .04 3.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.58,
    y: 135.65,
    width: 49.55,
    height: 21.83,
    rx: 3.77,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 101.19,
    cy: 143.21,
    r: 3.01,
    style: {
      fill: "#ffb600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.19 146.57a4.81 4.81 0 0 0-4.8 4.81H106a4.81 4.81 0 0 0-4.81-4.81ZM114.64 146.22a3 3 0 1 0-3-3 3 3 0 0 0 3 3ZM114.64 146.57a4.82 4.82 0 0 0-4.81 4.81h9.62a4.81 4.81 0 0 0-4.81-4.81ZM128.09 146.47a3.26 3.26 0 1 1 3.26-3.26 3.26 3.26 0 0 1-3.26 3.26Zm0-6a2.76 2.76 0 1 0 2.76 2.76 2.77 2.77 0 0 0-2.76-2.78Z",
    style: {
      fill: "#ffb600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.15 151.63H123v-.25a5.06 5.06 0 0 1 10.12 0Zm-9.61-.5h9.1a4.56 4.56 0 0 0-9.1 0Z",
    style: {
      fill: "#ffb600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.88 135.65h-8.62s7.22 5.8 7.39 5.8 1.23-5.8 1.23-5.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.61 301.77c-.74 0 5.84-14.13 5.8-14.4-.18-1.13 24.31 14.4 24.31 14.4Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.66 104.55a37.52 37.52 0 0 1 53.06 53.05l-21.19 21.2a7.54 7.54 0 0 1-10.66 0l-21.21-21.21a37.52 37.52 0 0 1 0-53.04Zm26.53 44a17.42 17.42 0 1 0-17.42-17.42 17.43 17.43 0 0 0 17.42 17.39Z",
    style: {
      fill: "#ffb600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffb600"
    },
    d: "M596.57 176.22h-1v-36.33H435.8v-1h160.77v37.33z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 596.07,
    cy: 174.17,
    r: 3.99,
    style: {
      fill: "#ffb600"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 700.78,
    cy: 137.06,
    r: 20.09,
    transform: "rotate(-29.82 700.804 137.05)",
    style: {
      fill: "#ffb600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffb600"
    },
    d: "m687.34 145.4-5.14-.58-2.11 6.18 6.4-.33.85-5.27zM725.22 136.34a.25.25 0 0 1-.23-.26 19.76 19.76 0 0 0-8-16.73.25.25 0 1 1 .29-.4 20.24 20.24 0 0 1 8.22 17.16.25.25 0 0 1-.28.23ZM724.4 142.24a.16.16 0 0 1-.1 0 .23.23 0 0 1-.13-.32 7.18 7.18 0 0 0 .53-2.82.23.23 0 0 1 .24-.25.24.24 0 0 1 .26.24 7.62 7.62 0 0 1-.57 3 .25.25 0 0 1-.23.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M701.28 137.14a4 4 0 1 0-4-4 4 4 0 0 0 4 4ZM701.28 137.61a6.43 6.43 0 0 0-6.43 6.44h12.87a6.44 6.44 0 0 0-6.44-6.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 278.38,
    cy: 174.17,
    r: 20.09,
    transform: "rotate(-68.34 278.363 174.167)",
    style: {
      fill: "#ffb600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffb600"
    },
    d: "m286.27 187.79-1.39 4.99 5.76 3.06.7-6.37-5.07-1.68zM302.82 173.46a.26.26 0 0 1-.24-.27 19.72 19.72 0 0 0-8-16.72.25.25 0 0 1 .29-.41 20.23 20.23 0 0 1 8.22 17.16.26.26 0 0 1-.27.24ZM302 179.36h-.1a.26.26 0 0 1-.13-.33 7 7 0 0 0 .53-2.81.25.25 0 1 1 .5 0 7.57 7.57 0 0 1-.57 3 .25.25 0 0 1-.23.14Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 278.38,
    cy: 170.72,
    r: 4.03,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.38 175.22a6.43 6.43 0 0 0-6.43 6.43h12.87a6.43 6.43 0 0 0-6.44-6.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m705.8 393.36 9.84-7.75c6.28 7.15 11.35 14.27 15.17 18.52l-2.37 5.57-6.44-1.28a187.61 187.61 0 0 0-16.2-15.06Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m715.23 403.63 3.83-2.44c3.92 2 4.7.4 5.18-3.12 1-.84 2.14.25 2.45.53l6.91 6.25a1.42 1.42 0 0 1 .12 2 1.64 1.64 0 0 1-.32.27l-9.19 5.88-12.88 8.2c-3.51 2.24-6.49-.83-5.25-2.08 5.59-5.58 9-10.42 9.78-13.6.14-.6-.38-.61-.63-1.89Z",
    style: {
      fill: "#ffb600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M718 407.28a.23.23 0 0 1-.11 0 3.74 3.74 0 0 0-3.12 0 .25.25 0 0 1-.33-.13.24.24 0 0 1 .12-.33 4.27 4.27 0 0 1 3.55 0 .25.25 0 0 1 .12.33.28.28 0 0 1-.23.13ZM717.1 409.68h-.11a3.74 3.74 0 0 0-3.12 0 .24.24 0 0 1-.33-.12.24.24 0 0 1 .12-.33 4.23 4.23 0 0 1 3.55 0 .25.25 0 0 1 .12.33.27.27 0 0 1-.23.12ZM715.64 412.15a.19.19 0 0 1-.1 0 3.8 3.8 0 0 0-3.13 0 .25.25 0 0 1-.21-.46 4.27 4.27 0 0 1 3.55 0 .24.24 0 0 1 .12.33.24.24 0 0 1-.23.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M733.72 406.84a1.64 1.64 0 0 1-.32.27l-9.19 5.89-12.88 8.2a4 4 0 0 1-4.64.1c.54-.34 26.25-16.44 26.51-16.77l.5.48a1.39 1.39 0 0 1 .02 1.83Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m647.73 393.08 15.27 9.41c-1.14 11.45-4 21.85-2.89 27.47l-4.92 3.53-6.71-7s.57-20.49-.75-33.41Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m647.87 421.44 4.54-.09c2.32 3.72 3.81 2.78 6 0 1.32-.18 1.7 1.32 1.82 1.73l2.66 8.92a1.42 1.42 0 0 1-.93 1.77 1.45 1.45 0 0 1-.41.06l-10.9.23-15.26.33c-4.16.08-5.11-4.09-3.4-4.51 7.67-1.87 13.07-4.25 15.41-6.55.47-.33.01-.66.47-1.89Z",
    style: {
      fill: "#ffb600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.47 426a.24.24 0 0 1-.21-.11 3.71 3.71 0 0 0-2.66-1.63.25.25 0 0 1-.22-.28.24.24 0 0 1 .28-.22 4.24 4.24 0 0 1 3 1.86.25.25 0 0 1-.07.34.23.23 0 0 1-.12.04ZM646.45 427.62a.26.26 0 0 1-.21-.11 3.76 3.76 0 0 0-2.66-1.64.25.25 0 0 1-.22-.27.24.24 0 0 1 .28-.22 4.26 4.26 0 0 1 3 1.85.26.26 0 0 1-.07.35.23.23 0 0 1-.12.04ZM643.93 429a.22.22 0 0 1-.21-.12 3.73 3.73 0 0 0-2.66-1.63.25.25 0 0 1-.22-.28.23.23 0 0 1 .27-.22 4.24 4.24 0 0 1 3 1.86.26.26 0 0 1-.2.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662 433.79a1.45 1.45 0 0 1-.41.06l-10.9.23-15.26.33a4 4 0 0 1-4-2.34c.63 0 31-.41 31.36-.56l.18.67a1.42 1.42 0 0 1-.97 1.61Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.35 174.47s-1.71-5.64.09-16.16l-.57-.2c.25-1.47.53-2.84.81-4a.28.28 0 0 0 0-.05l-13 10.19c.7 3.22.24 9.65-.15 12.39 0 0-1.22 5 5.21 4.5 4.74-.4 7.61-6.67 7.61-6.67Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m656 168.84 7.82-2.72c-.45 2.58-2.32 5.79-7.87 6.66a24.38 24.38 0 0 0 .05-3.94Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668 147.26c.06 8.94.27 14-3.93 18.82-6.31 7.27-17.33 4-20.07-4.74-2.46-7.9-2.15-21.19 6.35-25.25A12.34 12.34 0 0 1 668 147.26Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.43 136.47c-1.56-4.82-13.86-4-17.12-1.3-.49.41 7 3.58 6.59 3.45l3.51.95c.52-.15 1.6.39 2.25 2 0 0 .54 13.68 4.68 17.37 3-1.73 2.82-7.16 3.58-10.44 1.13-4.91 2.41-12.06-3.49-12.03Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.05 154.44a8.38 8.38 0 0 1-3.85 5.2c-2.57 1.5-3.76-1.34-3.7-4.16.06-2.54.59-5.67 3.48-6s4.71 2.28 4.07 4.96Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.46 150.7c.06.91-.37 1.67-1 1.71s-1.13-.68-1.19-1.59.37-1.68 1-1.71 1.13.68 1.19 1.59ZM646.53 151.48c.06.91-.37 1.68-1 1.72s-1.13-.68-1.19-1.59.37-1.68 1-1.71 1.13.67 1.19 1.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.41 150.78s-2.58 4.72-3.38 6.63c1.35 1.06 3.5.38 3.5.38Z",
    style: {
      fill: "#a24e3f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.39 146.25a.42.42 0 0 1-.43 0 3.43 3.43 0 0 0-3.06-.48.43.43 0 0 1-.56-.23.42.42 0 0 1 .22-.56 4.31 4.31 0 0 1 3.88.57.42.42 0 0 1 .12.59.46.46 0 0 1-.17.11ZM652.71 160.87a.38.38 0 0 1 0-.75 4.94 4.94 0 0 0 3.39-2 .37.37 0 0 1 .53 0 .38.38 0 0 1 0 .53 5.73 5.73 0 0 1-3.9 2.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666 155.31a.24.24 0 0 1-.24-.26 4.58 4.58 0 0 1 .72-2.3 3.13 3.13 0 0 1 1.58-1.33 1.88 1.88 0 0 1 2 .54.25.25 0 0 1 0 .35.24.24 0 0 1-.35 0 1.37 1.37 0 0 0-1.48-.37 2.55 2.55 0 0 0-1.3 1.11 4.1 4.1 0 0 0-.65 2.06.25.25 0 0 1-.28.2Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.33 147.91a.54.54 0 0 1-.23-.11.43.43 0 0 1 0-.6 4.2 4.2 0 0 1 3.59-1.47.42.42 0 0 1 .36.49.41.41 0 0 1-.48.35 3.3 3.3 0 0 0-2.83 1.2.44.44 0 0 1-.41.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670 132.48c-.83-1.94-3.45-2.16-5.37-1.59-.12-2.44-3.41-3.58-5.4-3.34a4 4 0 0 0-2.74 1.14c.16 0-.74-1.15-1.27-1.6a6.32 6.32 0 0 0-7.05-.75 6.89 6.89 0 0 0-3.3 6.53 3.39 3.39 0 0 0-4.81.52 3.86 3.86 0 0 0 .65 5.05 3 3 0 0 0-2.33 3.53 3 3 0 0 0 3.51 2.31c.25 1.79.63 4 .88 5.82l1.83-6.83c1.2-.54 1.39-1.13 1.52-2.5 1.06 1.62 2.48 1.36 4.31 1.13a5.15 5.15 0 0 0 4.11-3.45 5.5 5.5 0 0 0 5 2.68A4 4 0 0 0 663 137a4.23 4.23 0 0 0 5.46 1 4.64 4.64 0 0 0 1.54-5.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.53 173.9s8 .22 11.15 9.09c3 8.17 10.44 26.19 10.44 26.19l-17.91 5.24-7.13-21.33Z",
    style: {
      fill: "#ffb600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m654.29 259 10.79 23s-17.14 51.59-18.17 57-1.51 73.12-1.51 73.12h19.07L672 346s23.15-56.12 24.85-60.68c3.18-8.54-.15-20-.15-20l-5.9-8.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.81 270.53c0 2.09 7.44 73.55 8.66 73.81s55.12 59.2 55.12 59.2l15.3-13.44-39.54-53.62L679 288.3l-1.57-30.3-34.43 2.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4
    },
    d: "m669.97 362.98.95-16.79L682 321.64l-8.32 25.96-.79 17.77-2.92-2.39zM649.99 328.04l15.09-46.03-5.26-4.8 1.67 6.6-12.16 38.77.66 5.46z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m597.83 196.28 23.35 21.43 10.88-20.26s11.88 11.73 11.47 11.9-14 29.89-23.77 24.56-26.34-32.15-26.34-32.15Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.18 217.71s2 3.24 1.77 6.3a6.6 6.6 0 0 0 .63-3.93 9.6 9.6 0 0 0-1.46-4.12Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.67 179.22c6.38 3.27 8.94 14.89-4.76 42.91l-16.36-12.63c2.62-7 5.28-10.62 9.48-19.11 6.65-13.17 11.64-11.17 11.64-11.17Z",
    style: {
      fill: "#ffb600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.47 178.8c4.5-1 22.38-5.68 41.5-4.88l10.11 71.24s2 9.34 4.65 18.59c-18.22 10.55-43.5 12.25-57.06 6.5.18.28-.25-7.61-.83-19.17-1-20.37-2.54-52.15-2.07-70.7.02-.45 3.23-1.48 3.7-1.58Z",
    style: {
      fill: "#ffb600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      isolation: "isolate",
      opacity: 0.2
    },
    d: "m639.39 219.03-.64-23.04-2.91 24.54 2.07 1.6 1.48-3.1zM688.21 214.13l-1 .29-6.52-17.47 4.89 19.99 3.33.02-.7-2.83z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.08 200s1.79-2.83 1.15-5.52-.43-5-1-7-1.73.58-2 2.06-.69 3.15-1.77 2.74-7.28-8.12-8.83-8.53-.94 1.15-.94 1.15-1.56-1.83-2.45-1.41c-.23.11-.59.74 0 1.68 1.3 2.13 4.27 6.45 4.27 6.45-.17-.25-4.21-5.32-4.92-6-.92-.89-1.8-.84-2.3-.29-.71.78 4.09 7.24 4.1 7.66 0 0-2.64-3.82-4-3.67s.18 2.63 1.94 4.57c1.62 1.78 4.33 5.69 6.15 7.33 2.25 2 4.21 2.89 6.81 1.76a9.51 9.51 0 0 0 3.79-2.98Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.29 189.88a.11.11 0 0 1-.1-.06c-1.07-1.6-2.22-3.16-3.42-4.64a.12.12 0 0 1 0-.18.12.12 0 0 1 .17 0c1.21 1.49 2.36 3.06 3.44 4.66a.14.14 0 0 1 0 .18ZM586.27 194.63a.11.11 0 0 1-.07 0 .12.12 0 0 1 0-.17 13 13 0 0 1 5.91-4.52.13.13 0 0 1 .08.24 12.77 12.77 0 0 0-5.79 4.42.11.11 0 0 1-.13.03ZM595.79 199.21a.14.14 0 0 1-.1-.05 4.53 4.53 0 0 1 .28-5.77.14.14 0 0 1 .18 0 .13.13 0 0 1 0 .18 4.27 4.27 0 0 0-.27 5.45.12.12 0 0 1 0 .17.13.13 0 0 1-.09.02Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.77 209.57s5.39 12.76 7.67 24.21c1 5.2-3.12 8.54-7.37 9.56-13.4 3.24-43.6 3.25-43.6 3.25l-.79-9.21 34.78-7.52-6.25-15.73Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m660.4 248.56-11.4 1.28a1.31 1.31 0 0 1-1.06-.37l-17.35-17.15a1.3 1.3 0 0 1 .58-2.18l10-2.58a1.27 1.27 0 0 1 1.23.33l18.73 18.45a1.3 1.3 0 0 1-.73 2.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.46 237.43s-.32-1.34-5.36-2.88c-3.83-1.17-7.64-4.75-8.26-4.63s-1.29 2.08.3 3.8 3.24 2.7 2.82 3.36c-1 1.59-13.48.29-13.7 1.65s2.17 5.26 8.84 7.86 15.83 0 15.83 0Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M598.54 389.06 72.69 401.38v-89.94H603.6l-5.06 77.62z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      isolation: "isolate",
      opacity: 0.5
    },
    d: "M598.54 389.06 72.69 401.38v-89.94H603.6l-5.06 77.62z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.46 334.52v45.61a22.29 22.29 0 0 0 15.7 21.29l3.72 1.13a22 22 0 0 0 7.07 1l24.56-.58a62.22 62.22 0 1 1 120.39-2.86l249.9-5.94a63.4 63.4 0 0 1-.59-8.81 62.22 62.22 0 1 1 124.43.54c0 1.21-.09 2.4-.09 3.6a10.59 10.59 0 0 0 1-.43l8.55-3.81a23.54 23.54 0 0 0 13.85-21.45v-92.9a23.51 23.51 0 0 0-12.57-20.82l-64.23-33.78a3.39 3.39 0 0 1 .42-6.17l7.86-2.82a1.83 1.83 0 0 0-.36-3.55c-30.53-4.28-149.23-19.77-211.63-12.17-72 8.81-140.95 71.27-140.95 71.27-53-2-102.41 16.45-123.7 25.7a26.61 26.61 0 0 0-14.55 15.87L54 326a27 27 0 0 0-1.54 8.52Z",
    style: {
      fill: "#ffb600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.87 394.15a60.24 60.24 0 0 1-.54-8.27c0-1.41 0-2.8.13-4.19l-45.19-18.49a19.08 19.08 0 0 0-8.35-1.36l-157.18 10.32a18.61 18.61 0 0 0-7.37 2l-29.86 15.36a64.69 64.69 0 0 1-1.51 10.57ZM621 363.79v-2.37l-25.56 7.82a62.38 62.38 0 0 1 2.24 16.64c0 1.21-.09 2.4-.09 3.6a10.59 10.59 0 0 0 1-.43l8.57-3.81A23.54 23.54 0 0 0 621 363.79ZM59.72 396.5a22.14 22.14 0 0 0 8.53 4.92l3.75 1.13a22 22 0 0 0 7.08 1l24.52-.55a61.13 61.13 0 0 1-1.92-9.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.59 317.82a68 68 0 0 0-67.54 76.47l5.9-.14a62.22 62.22 0 1 1 123.84-8.27c0 1.21-.1 2.4-.1 3.6a10.75 10.75 0 0 0 1-.43l4.91-2.22v-.95a68.13 68.13 0 0 0-68.07-68.06ZM163.42 317.82a68.06 68.06 0 0 0-65.87 85.27l6-.14A62.21 62.21 0 1 1 224 400.09l6-.15a68.05 68.05 0 0 0-66.59-82.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.65 265.48a4.69 4.69 0 0 0 1.37 7.85l26 7.28a17.68 17.68 0 0 0 7.05.53l192.6-23.86a19.64 19.64 0 0 0 12.33-6.86L487.29 221a6.5 6.5 0 0 0 1.51-3.59c.35-3.35-1.76-6.37-4.69-6.75-46.11-6.13-104.44-11.66-141.26-7.2-48.26 5.89-96.85 42.17-120.2 62.02Z",
    style: {
      fill: "#ffb600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.52 265.48a4.69 4.69 0 0 0 1.37 7.85l26 7.28a17.7 17.7 0 0 0 7.05.53l188.3-12.9c4.69-.6 11.93-9.21 17.05-16.21L488.15 221a6.44 6.44 0 0 0 1.52-3.59c.34-3.35-1.76-6.37-4.69-6.75-46.13-6.11-104.44-11.67-141.26-7.18-48.27 5.87-96.85 42.15-120.2 62Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.34 283.84a2.39 2.39 0 0 1-1.43-3 4 4 0 0 1 3.59-2.64l22.92-1a2.34 2.34 0 0 1 .91.13 2.41 2.41 0 0 1 1.45 3.06 4 4 0 0 1-3.61 2.63l-22.92 1a2.34 2.34 0 0 1-.91-.18Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.8 218.16a4.93 4.93 0 0 0-.4 6.94l5.43 5.91a5.1 5.1 0 0 0 2.3 1.39l66.58 18.47a13.81 13.81 0 0 0 3.56.47h13.23c-.69-.46-1.4-.88-2.13-1.27l-64.23-33.81a3.27 3.27 0 0 1-1.48-4.38l-20.86 5.22a5 5 0 0 0-2 1.06Z",
    style: {
      fill: "#ffb600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m105.16 297.27-22.72-2.48-13 5.34a9.34 9.34 0 0 0-5.53 6.35 6.55 6.55 0 0 0 .67 4.92l.23.39a7.16 7.16 0 0 0 7.17 3.5l13.1-1.8a7.66 7.66 0 0 0 3.47-1.49l15.11-11.47Z",
    style: {
      fill: "#fff",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m199.54 262.84 3.62 1a8.77 8.77 0 0 0 8.07-1.74c21.06-17.81 57.67-45.14 97.17-57.87a.74.74 0 0 0 .13-1.35l-4.91-2.52c-56.99 19.79-104.08 62.48-104.08 62.48Z",
    style: {
      fill: "#ffb600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m199.54 262.84 3.62 1a8.77 8.77 0 0 0 8.07-1.74c21.06-17.81 57.67-45.14 97.17-57.87a.74.74 0 0 0 .13-1.35l-4.91-2.52c-56.99 19.79-104.08 62.48-104.08 62.48Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.46 286.89 224 300.58l3.61 23.62a49.89 49.89 0 0 0 7.85 20.22l16 23.92 163.42-22.1 77.27-59.35Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 535.53,
    cy: 385.87,
    r: 51.84,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 535.53,
    cy: 385.87,
    r: 31.78,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 532.99,
    y: 357.29,
    width: 5.09,
    height: 21.37,
    rx: 2.54,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 532.99,
    y: 393.1,
    width: 5.09,
    height: 21.37,
    rx: 2.54,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M545.24 383.21a2.54 2.54 0 0 1-3.46-.95 2.54 2.54 0 0 1 .93-3.46l14.1-8.19a2.56 2.56 0 0 1 3.49.94 2.56 2.56 0 0 1-.94 3.47l-14.09 8.18Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M514.23 401a2.54 2.54 0 0 1-3.46-.93 2.53 2.53 0 0 1 .93-3.46l14.1-8.19a2.53 2.53 0 0 1 3.47.92 2.54 2.54 0 0 1-.92 3.48L514.24 401Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m556.81 401.1-14.1-8.18a2.56 2.56 0 0 1-.93-3.49 2.57 2.57 0 0 1 3.49-.92l14.09 8.19a2.56 2.56 0 0 1 .94 3.47 2.55 2.55 0 0 1-3.49.93Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M529.27 382.27a2.54 2.54 0 0 1-3.47.92L511.7 375a2.53 2.53 0 0 1-.93-3.46 2.55 2.55 0 0 1 3.47-.93l14.11 8.19a2.53 2.53 0 0 1 .91 3.47Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M531.27 385.86a4.26 4.26 0 0 1 4.26-4.26 4.28 4.28 0 1 1-4.27 4.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 163.42,
    cy: 385.88,
    r: 51.84,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 163.42,
    cy: 385.88,
    r: 31.78,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 160.87,
    y: 357.29,
    width: 5.09,
    height: 21.37,
    rx: 2.54,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 160.87,
    y: 393.1,
    width: 5.09,
    height: 21.37,
    rx: 2.54,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.11 383.21a2.51 2.51 0 0 1-3.43-.95 2.53 2.53 0 0 1 .91-3.47l14.12-8.19a2.54 2.54 0 0 1 3.47.94 2.54 2.54 0 0 1-.94 3.47l-14.09 8.18Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.65 400.11a2.53 2.53 0 0 1 .93-3.46l14.1-8.19a2.55 2.55 0 0 1 3.49.92 2.55 2.55 0 0 1-.94 3.48L142.14 401a2.56 2.56 0 0 1-3.49-.89Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M188.17 400.18a2.52 2.52 0 0 1-3.46.92l-14.12-8.18a2.56 2.56 0 0 1-.91-3.49 2.54 2.54 0 0 1 3.47-.92l14.09 8.19a2.55 2.55 0 0 1 .93 3.47Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.15 382.29a2.53 2.53 0 0 1-3.47.9l-14.1-8.19a2.53 2.53 0 0 1-.93-3.46 2.56 2.56 0 0 1 3.49-.94l14.09 8.19a2.55 2.55 0 0 1 .93 3.47Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M163.42 381.6a4.28 4.28 0 1 1-4.27 4.28 4.28 4.28 0 0 1 4.27-4.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.52 288.09a3.27 3.27 0 0 0 2.15-4.1c-.6-10.92-2.92-20.63-9.61-27.31a3.28 3.28 0 0 0-3.39-2.31l-39.5 3.73a3.21 3.21 0 0 0-1.85.83 3.26 3.26 0 0 0-.23 4.62l11.31 12.2a3.29 3.29 0 0 0 1.44.9l37.82 11.46a3.36 3.36 0 0 0 1.86-.02Z",
    style: {
      isolation: "isolate",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.19 268a4.46 4.46 0 0 0 2.83 5.34l26 7.28a28.81 28.81 0 0 0 7.22 1.24l8.18-.55-7.72-41.67c-17.81 11.7-19 12.24-35 25.86a4.45 4.45 0 0 0-1.51 2.5ZM390.41 202.12l-16.32 71.16 21.35-1.54 9.74-69q-7.48-.38-14.77-.62ZM458.14 258.43l30-37.45a6.45 6.45 0 0 0 1.55-3.64C490 214 487.9 211 485 210.6c-6.14-.83-12.68-1.63-19.21-2.42",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.81 275.2a9.39 9.39 0 0 1-9.5-9.28 9.42 9.42 0 0 1 7.27-9.28l12.52-2.93 3.19 21-13.23.51Z",
    style: {
      fill: "#ffb600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      isolation: "isolate",
      opacity: 0.30000000000000004
    },
    d: "m254.62 274.83 3.67-.14-3.19-20.98-3.57.84 3.09 20.28z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.69 364.8h-.05a.24.24 0 0 1-.19-.29c.13-.65 13.82-64.89 15.57-73.64.67-3.36.92-9.78.72-19.11a.25.25 0 0 1 .25-.25.25.25 0 0 1 .25.24c.2 9.36-.05 15.83-.73 19.22-1.75 8.75-15.44 73-15.58 73.64a.24.24 0 0 1-.24.19ZM255.37 374.44a.26.26 0 0 1-.21-.11c-.17-.26-17.83-26.4-23.9-37.33-6.26-11.25-10.26-65.16-10.44-67.45a.26.26 0 0 1 .23-.27.25.25 0 0 1 .27.23c0 .56 4.2 56.09 10.38 67.25 6.05 10.91 23.7 37 23.88 37.29a.25.25 0 0 1-.07.35.33.33 0 0 1-.14.04ZM82.44 295a.25.25 0 0 1-.09-.48c13.54-5.54 57-16 67.14-17.61 12.83-2.06 56.67-12.88 57.11-13a.25.25 0 0 1 .3.19.24.24 0 0 1-.18.3c-.44.11-44.3 10.93-57.16 13-9.89 1.59-53.82 12.18-67 17.58a.2.2 0 0 1-.12.02Z",
    style: {
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.8 218.16a4.93 4.93 0 0 0-.4 6.94l5.43 5.91a5.1 5.1 0 0 0 2.3 1.39l66.58 18.47a13.81 13.81 0 0 0 3.56.47h13.23c-.69-.46-1.4-.88-2.13-1.27l-64.23-33.81a3.27 3.27 0 0 1-1.48-4.38l-20.86 5.22a5 5 0 0 0-2 1.06Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.71 260.72c-.6.36-7.67 7.67-7.67 7.67l1.38 9.06 8.89-9.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.36 279.61a3.16 3.16 0 0 1-4.23-1.43L262 249.6a3.15 3.15 0 0 1 1.43-4.22 3.15 3.15 0 0 1 4.23 1.43l14.1 28.58a3.15 3.15 0 0 1-1.4 4.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.75 245.21s7 27.92 11.09 29c7.44 1.91 33-.23 32.5-1.05l-1.08-12.84s-25.77 4.26-25.57 3.81L303 242.4Z",
    style: {
      fill: "#ebb373"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.18 244.09s2.3-2.14 2.36-4.74.81-4.65.72-6.58-1.7.12-2.34 1.38-1.38 2.7-2.25 2.06-4.67-9.1-6-9.84-1.12.82-1.12.82-1-2-1.89-1.86c-.24 0-.72.53-.41 1.52.67 2.24 2.33 6.87 2.33 6.87-.09-.27-2.55-5.83-3-6.62-.63-1-1.44-1.19-2-.81-.83.54 2 7.54 1.9 7.92 0 0-1.49-4.08-2.75-4.28s-.47 2.43.67 4.61c1 2 2.57 6.19 3.83 8.12 1.55 2.37 3.12 3.62 5.75 3.22a9 9 0 0 0 4.2-1.79Z",
    style: {
      fill: "#ebb373"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.75 232.59a.12.12 0 0 1-.12-.08c-.59-1.7-1.26-3.39-2-5a.12.12 0 0 1 .07-.17.12.12 0 0 1 .16.06c.74 1.65 1.42 3.34 2 5.05a.12.12 0 0 1-.07.16ZM291 235.94a.13.13 0 0 1-.1 0 .14.14 0 0 1 0-.18 12.22 12.22 0 0 1 6.43-2.69.13.13 0 0 1 .14.12.12.12 0 0 1-.11.13 11.9 11.9 0 0 0-6.3 2.64ZM298.51 242.37a.13.13 0 0 1-.12-.08 4.26 4.26 0 0 1 1.64-5.17.12.12 0 0 1 .17 0 .12.12 0 0 1 0 .17 4 4 0 0 0-1.54 4.86.13.13 0 0 1-.06.17Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.74 258.36c-4.68-6.18-12.11-5.56-16.94-4.71l-9.56 1.57a5.38 5.38 0 0 0-.9.22l-2.18.67-20.47 6.56 4.94 13.1 6.69-.82-1.12 1.81 6.56-.42 35.81-1.87v-7.26a14.64 14.64 0 0 0-2.83-8.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.8 268.67s-4.49 30.11-7.67 33.3c-7.58 7.62-35.65-13.34-35.65-13.34l.87-8.09 24.24 10 4.54-25.54Z",
    style: {
      fill: "#ebb373"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.49 266.62c-.22.74-2.15 21.75-2.15 21.75l-20.56-1.92s1.07-5.83 2.62-16c1.63-10.63 2.57-16 7.84-16.86 9.97-1.67 12.25 13.03 12.25 13.03ZM363.6 219.05c3.1 5.44 4.18 8.69 4.46 13.91.33 6.09.05 11.47-1.31 13-1.78 2-21.06 4-31.87 3.53-.39 0-.71-3.44-.71-3.44s-1.53 3.35-2 3.32c-2.95-.13-4.84-.24-4.84-.24s2.45-5 5.44-23.18c1.46-8.86 10.38-12.4 15.63-13.07 8.72-1.08 15.2 6.17 15.2 6.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.91 236.17c-2.83-4.89-5.64-18.07 6.15-22.13 14.71-5.08 21.29 4.3 22.56 13.6s-4 16.32-13.7 15.62-13.06-3.7-15.01-7.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m358.33 236.83-8.69 8-1.64 1.78a16.3 16.3 0 0 1 1 3.79 5.56 5.56 0 0 1-1.09 3.84l-1.95 4.44c4.35-3.41 14.26-5.24 14.26-5.24a45.41 45.41 0 0 1-1.89-16.61Z",
    style: {
      fill: "#ebb373"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349 250.88c2.34-1.25 5-3.48 4.78-6.18a12.47 12.47 0 0 0-.51-2.92l-4.93 5.92a15.23 15.23 0 0 1 .66 3.18Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.1 228c-1.18 8.5-1.5 12.11-6.11 16.38-6.93 6.42-17 3.68-18.37-4.85-1.23-7.69.9-20.29 9.44-23.48A11 11 0 0 1 361.1 228Z",
    style: {
      fill: "#ebb373"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.26 230.55c-.09.86-.65 1.54-1.25 1.52s-1-.72-.94-1.58.65-1.54 1.25-1.52 1.03.72.94 1.58ZM341.4 230c-.09.82-.64 1.47-1.23 1.46s-1-.7-.92-1.51.64-1.47 1.23-1.46 1 .67.92 1.51ZM351.61 227.45a.39.39 0 0 1-.33-.08 3.56 3.56 0 0 0-3.08-.64.41.41 0 0 1-.54-.26.46.46 0 0 1 .32-.54 4.4 4.4 0 0 1 3.9.77.39.39 0 0 1 0 .59.47.47 0 0 1-.27.16ZM338.57 225.7a.39.39 0 0 1-.19-.23.42.42 0 0 1 .3-.51 4.4 4.4 0 0 1 3.86.56.38.38 0 0 1 0 .57.46.46 0 0 1-.61 0 3.54 3.54 0 0 0-3.06-.41.44.44 0 0 1-.3.02ZM354.32 220c-2.84 2.72-2 13.55 5.56 15.31 8.87-1.62 2.94-23.4-5.56-15.31ZM343.28 238.05a24.59 24.59 0 0 1 1.38 3.21l.61-.1c2.74-.51 3.85-1.66 4.24-2.77a3.65 3.65 0 0 0 .14-1.7 3.59 3.59 0 0 0-.26-.94c-1.29 1.14-3.82 1.81-5.18 2.11-.57.14-.93.19-.93.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m344.21 237.86.43.94c2.59-.49 4.34-1.18 5-2.11a3.59 3.59 0 0 0-.26-.94c-1.28 1.14-3.81 1.81-5.17 2.11Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.27 241.16c2.74-.51 3.85-1.66 4.24-2.77a9 9 0 0 0-2.93 1.17 3.34 3.34 0 0 0-1.31 1.6Z",
    style: {
      fill: "#dc5753"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.82 229.49a26.28 26.28 0 0 1-3.55 5.58c1 1.1 3 .64 3 .64Z",
    style: {
      fill: "#e4873e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m347.64 228.48 1.94.56c-.94.96-1.94-.56-1.94-.56ZM338.9 228l1.93.56c-.93.94-1.93-.56-1.93-.56ZM346.21 214.17c-3.43 1-7.27 6.65-8 8.87 4.75 1 17.87-2.89 17.87-2.89s8.51 2.78 4.34-1.79-14.21-4.19-14.21-4.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.36 235a6.9 6.9 0 0 1-4.3 3c-2.28.46-3.28-3.23-2.41-5.45a4.53 4.53 0 0 1 5.25-2.7c2.1.59 2.7 3.23 1.46 5.15Z",
    style: {
      fill: "#ebb373"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m323.76 248.32-.26-.43c3.2-1.92 6.25-9.39 7.55-12.58a52.8 52.8 0 0 0 2.73-11l.5.09a53.64 53.64 0 0 1-2.77 11.06c-1.43 3.54-4.41 10.85-7.75 12.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.39 237.8a1.59 1.59 0 1 0 1.66-1.51 1.58 1.58 0 0 0-1.66 1.51Z",
    style: {
      fill: "#ffb600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.28 235a.25.25 0 0 1-.23-.27 2.85 2.85 0 0 1 3.73-2.47.26.26 0 0 1 .16.32.25.25 0 0 1-.32.16 2.34 2.34 0 0 0-3.07 2 .25.25 0 0 1-.27.26Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m333.89 286.14-9.54-5.6-2.6-3.33s-2.68-3.16-4.84-3.37a6.77 6.77 0 0 0-3.14.66s-2.5 1.58-1 4c0 0-2.47 1.27-.79 4 0 0-2.37.05-.34 2.53a9.14 9.14 0 0 0 6.32 3.26 11.61 11.61 0 0 0 4.19-.37l10.53 6.92Z",
    style: {
      fill: "#ebb373"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m349.58 275.65 1.72-10.79-5.25 10.91 3.53-.12M330.32 274.95l4.29-8.71-8.24 9.2 3.95-.49z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.698832e5948d697c989fecc8e73a309a.svg";
export { ForwardRef as ReactComponent };